var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4849 0H4.19917C1.91917 0 0.591675 1.335 0.591675 3.6225V11.37C0.591675 13.695 1.91917 15 4.19917 15H10.4849C12.8017 15 14.0917 13.695 14.0917 11.37V3.6225C14.0917 1.335 12.8017 0 10.4849 0Z",
    fill: "#977DB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4014 3.4873V3.4948C4.07815 3.4948 3.8164 3.7573 3.8164 4.0798C3.8164 4.4023 4.07815 4.6648 4.4014 4.6648H6.64318C6.96643 4.6648 7.22893 4.4023 7.22893 4.07155C7.22893 3.7498 6.96643 3.4873 6.64318 3.4873H4.4014ZM10.2814 8.0548H4.4014C4.07815 8.0548 3.8164 7.7923 3.8164 7.4698C3.8164 7.1473 4.07815 6.88405 4.4014 6.88405H10.2814C10.6039 6.88405 10.8664 7.1473 10.8664 7.4698C10.8664 7.7923 10.6039 8.0548 10.2814 8.0548ZM10.2814 11.4823H4.4014C4.1764 11.5123 3.9589 11.3998 3.8389 11.2123C3.7189 11.0173 3.7189 10.7698 3.8389 10.5823C3.9589 10.3873 4.1764 10.2823 4.4014 10.3048H10.2814C10.5807 10.3348 10.8064 10.5898 10.8064 10.8973C10.8064 11.1966 10.5807 11.4523 10.2814 11.4823Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewInvoice);
export default __webpack_public_path__ + "static/media/viewInvoice.b62c2b970bf8cce7158f9d568f74c666.svg";
export { ForwardRef as ReactComponent };